// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__dUvH8","active":"NavigationItem_active__3gpoh"};